import { LinkBreak } from '@phosphor-icons/react';

export default LinkBreak;
